module.exports = __webpack_public_path__ + "static/37210717895932766.d2642901.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/press-logos/37210717895932766.png
// module id = 1051
// module chunks = 213534597649335